import { InfoSVG } from "@components/svgs";
import { DELAY_TIME } from "@constants";
import {
  CheckboxProps,
  IconButton,
  PopperProps,
  Tooltip,
  useTheme,
} from "@mui/material";
import { useToggle } from "react-use";
import { SHButton, SHButtonProps } from "../sh-button";
import { SHCheckbox } from "../sh-checkbox";
import { SHBox } from "@components/design-systems";

type SHCheckboxButtonProps = (SHButtonProps | CheckboxProps) & {
  onClick: (value: boolean) => void;
  label: string | JSX.Element;
  value: boolean;
  size?: "small" | "medium";
  tooltipTitle?: string;
  sxTooltipPopper?: PopperProps["sx"];
};
export const SHCheckboxButton = ({
  label,
  value,
  disabled,
  tooltipTitle,
  onClick,
  sxTooltipPopper,
}: SHCheckboxButtonProps): JSX.Element => {
  const { palette } = useTheme();
  const [isChecked, setIsChecked] = useToggle(value);
  return (
    <Tooltip
      title={tooltipTitle}
      enterDelay={DELAY_TIME}
      enterNextDelay={DELAY_TIME}
      placement="top"
      slotProps={{
        popper: {
          sx: sxTooltipPopper,
        },
      }}
    >
      <SHBox component={"span"}>
        <SHButton
          color="primary"
          variant="outlined"
          disabled={disabled}
          sx={{
            alignContent: "space-between",
            "&:active": {
              ".MuiTypography-root": {
                color: palette.common.white,
              },
              backgroundColor: palette.primary.main,
              borderColor: palette.common.white,
              "&>button": {
                borderColor: palette.common.white,
              },
              "&>svg>path": {
                fill: palette.common.white,
              },
              "&>button>svg>path": {
                fill: palette.common.white,
              },
              "&>span>svg>path": {
                fill: palette.common.white,
              },
            },
            "&:disabled": {
              border: `1px solid ${palette.text.disabled}`,
              ".MuiTypography-root": {
                color: palette.text.disabled,
              },
              "&>button": {
                borderColor: palette.text.disabled,
              },
              "&>button>svg>path": {
                fill: palette.text.disabled,
              },
              "&>svg>path": {
                fill: palette.text.disabled,
              },
              "&>span>svg>path": {
                fill: palette.text.disabled,
              },
            },
          }}
          onClick={() => {
            setIsChecked(!isChecked);
            onClick(!isChecked);
          }}
        >
          <SHCheckbox
            sx={{
              width: "20px",
              marginRight: "5px",
              marginTop: "-3px",
              "&:hover": {
                backgroundColor: "transparent !important",
              },
            }}
            checked={isChecked}
          />
          {label}
          <IconButton
            component={"span"}
            disableRipple
            sx={{
              width: "16px",
              height: "16px",
              margin: "-1px -4px 2px 8px !important",
              p: 0,
              borderStyle: "solid",
              borderWidth: "1px",
              backgroundColor: "transparent",
              borderColor: palette.text.primary,
            }}
          >
            <InfoSVG />
          </IconButton>
        </SHButton>
      </SHBox>
    </Tooltip>
  );
};
